import React from "react"
import { DatoContentBaseProps } from "../../types"
import FeaturedVideo from "@components/FeaturedVideo"

interface DatoCmsComponentFeaturedVideoProps extends DatoContentBaseProps {}

const stripHash = (value?: string) =>
  value?.startsWith("#") ? value.slice(1) : value

const DatoCmsComponentFeaturedVideo: React.FC<
  DatoCmsComponentFeaturedVideoProps
> = ({
  title,
  sectionButtonText,
  sectionButtonLink,
  sectionButtonTextColor,
  sectionButtonColor,
  backgroundImage,
  backgroundColor,
  primaryVideoThumbnail,
  primaryVideoPreview,
  primaryVideoLink,
  leftVideoThumbnail,
  leftVideoPreview,
  leftVideoLink,
  rightVideoThumbnail,
  rightVideoPreview,
  rightVideoLink,
}) => {
  return (
    <FeaturedVideo
      title={title}
      sectionButtonText={sectionButtonText}
      sectionButtonLink={sectionButtonLink}
      sectionButtonTextColor={stripHash(sectionButtonTextColor?.hex)}
      sectionButtonColor={stripHash(sectionButtonColor?.hex)}
      backgroundImageSrc={
        backgroundImage?.responsiveImage?.src || backgroundImage?.url
      }
      backgroundColor={stripHash(backgroundColor?.hex)}
      primaryVideoThumbnail={
        primaryVideoThumbnail?.responsiveImage?.src ||
        primaryVideoThumbnail?.url
      }
      primaryVideoPreview={primaryVideoPreview?.url}
      primaryVideoStreamingUrl={primaryVideoPreview?.video?.streamingUrl}
      primaryVideoFallbackUrl={
        primaryVideoPreview?.video?.mp4Low || primaryVideoPreview?.url
      }
      primaryVideoLink={primaryVideoLink}
      leftVideoThumbnail={
        leftVideoThumbnail?.responsiveImage?.src || leftVideoThumbnail?.url
      }
      leftVideoPreview={leftVideoPreview?.url}
      leftVideoStreamingUrl={leftVideoPreview?.video?.streamingUrl}
      leftVideoFallbackUrl={
        leftVideoPreview?.video?.mp4Low || leftVideoPreview?.url
      }
      leftVideoLink={leftVideoLink}
      rightVideoThumbnail={
        rightVideoThumbnail?.responsiveImage?.src || rightVideoThumbnail?.url
      }
      rightVideoPreview={rightVideoPreview?.url}
      rightVideoStreamingUrl={rightVideoPreview?.video?.streamingUrl}
      rightVideoFallbackUrl={
        rightVideoPreview?.video?.mp4Low || rightVideoPreview?.url
      }
      rightVideoLink={rightVideoLink}
    />
  )
}

export default DatoCmsComponentFeaturedVideo
